type FittablePath = {
  samples: readonly unknown[]
  authoring?: { points: readonly unknown[] } | null
}

/** Сырой пролёт ещё не кривая: есть кадры и нет точек. */
export function pathNeedsFit(path: FittablePath): boolean {
  return (path.authoring?.points.length ?? 0) === 0 && path.samples.length >= 2
}

export type PathFitDecision = { apply: boolean; rewind: boolean }

/**
 * Номер запроса на подбор. Ответ со старым номером не применяется.
 * Ожидание резолвится и при отмене, чтобы экспорт не висел.
 */
export function createPathFitGate() {
  let token = 0
  let rewind = false
  let resolveWait = () => {}
  let wait = Promise.resolve()

  const armWait = () => {
    wait = new Promise((resolve) => {
      resolveWait = resolve
    })
  }

  return {
    cancel() {
      token += 1
      rewind = false
      resolveWait()
      wait = Promise.resolve()
      resolveWait = () => {}
    },
    suppressRewind() {
      rewind = false
    },
    begin(rewindAfter: boolean) {
      resolveWait()
      token += 1
      rewind = rewindAfter
      armWait()
      return token
    },
    finish(responseToken: number, playing: boolean, exporting: boolean): PathFitDecision {
      if (responseToken !== token) return { apply: false, rewind: false }
      const shouldRewind = rewind && !playing && !exporting
      rewind = false
      token += 1
      resolveWait()
      wait = Promise.resolve()
      resolveWait = () => {}
      return { apply: true, rewind: shouldRewind }
    },
    settled() {
      return wait
    },
  }
}
